import { useCallback } from 'react';
import { useIntl } from '@atlassian/jira-intl';

export const useFormatStoryPointsTotal = () => {
	const { formatNumber } = useIntl();

	// fix for floating point math issues (like 0.1 + 0.2 becomes 0.30000000000000004)
	// as the numbers end with lots of zeroes followed by a single digit, trimming
	// after 8 decimal points results in a sane representation
	return useCallback(
		(total: number) => formatNumber(total, { maximumFractionDigits: 8 }),
		[formatNumber],
	);
};
